import { ResubmitIndicationButton, ResubmitLabel } from '@/components/Chat/ResubmitIndicationButton'
import { RocklakeLineState } from '@/models/insuranceApplication'
import { CoverageType } from '@/models/insuranceCoverage'
import { Vendor } from '@/models/insuranceTypes'

const LINE_NAMES: Record<CoverageType, string> = {
  [CoverageType.AUTO_LIABILITY]: 'Auto liability',
  [CoverageType.AUTO_PHYSICAL_DAMAGE]: 'Physical damage',
  [CoverageType.GENERAL_LIABILITY]: 'General liability',
  [CoverageType.MOTOR_TRUCK_CARGO]: 'Cargo',
  [CoverageType.WORKERS_COMPENSATION]: 'Workers comp',
  [CoverageType.PET]: 'Pet insurance',
  [CoverageType.TOOLS_AND_EQUIPMENT]: 'Tools and equipment',
}

/** One Rocklake line on the staff card: a Submit button, or why there isn't one. */
export function RocklakeLineRow({
  coverage,
  state,
  applicationId,
  orgId,
}: {
  coverage: CoverageType
  state: RocklakeLineState
  applicationId: string
  orgId?: string
}) {
  const name = LINE_NAMES[coverage]
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex flex-col">
        <span className="text-general-foreground text-md font-medium">{name}</span>
        {state === RocklakeLineState.NOT_PICKED && (
          <span className="text-muted-foreground text-sm font-normal">
            The customer didn't pick {name.toLowerCase()}. Add it under Change coverages to send it.
          </span>
        )}
      </div>
      {state === RocklakeLineState.READY && (
        <ResubmitIndicationButton
          vendor={Vendor.ROCKLAKE}
          vendorName={`Rocklake ${name.toLowerCase()}`}
          applicationId={applicationId}
          orgId={orgId}
          label={ResubmitLabel.SUBMIT}
          coverageLine={coverage}
        />
      )}
    </div>
  )
}
